var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "question-display",
      attrs: { id: "question-" + _vm.activeQuestion.TEST_QUESTION_RID }
    },
    [
      _c("div", { staticClass: "sr-only" }, [
        _c("p", [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.testTaker.questionNumber", {
                  number: _vm.activeQuestion.index + 1
                })
              ) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pull-right" }, [
        _c("span", { staticClass: "pill pill-dark" }, [
          _c("strong", [_vm._v(_vm._s(_vm.activeQuestion.TOTAL_POINTS))]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("MAIN_CONTENT.ShortFillQuestion.ptsPossible")) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-type-instructions" }, [
        _c("strong", [_vm._v(_vm._s(_vm.activeQuestion.QUESTION_NAME))]),
        _vm._v(" "),
        _c("span", { staticClass: "hint" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.$t("MAIN_CONTENT.ShortFillQuestion.enterMessage")) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("h3", {
        staticClass: "question-text",
        domProps: { innerHTML: _vm._s(_vm.activeQuestion.QUESTION_TEXT) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "answers" }, [
        _c("div", { class: _vm.getAnswerClass() }, [
          _c(
            "div",
            { class: ["answer-number", { selected: _vm.answeredByStudent() }] },
            [
              _vm.answeredByStudent()
                ? _c("i", { staticClass: "fas fa-arrow-circle-right" })
                : _vm._e(),
              _vm._v(" "),
              _vm.isGraded() && _vm.isCorrect()
                ? _c(
                    "div",
                    {
                      staticClass: "badge badge-dark answer-points float-right"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.testTaker.points", {
                              points: _vm.studentAnswer[0].POINTS_EARNED.toFixed(
                                2
                              )
                            })
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "answer-text form" }, [
            (!_vm.isGraded(_vm.studentAnswer) || _vm.allowChanges) &&
            _vm.testMode !== "grading"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.answerData.answer[0].TEST_QUESTION_ANSWER_TEXT,
                      expression:
                        "answerData.answer[ 0 ].TEST_QUESTION_ANSWER_TEXT"
                    }
                  ],
                  ref: "answerRef",
                  staticClass: "form-control",
                  domProps: {
                    value: _vm.answerData.answer[0].TEST_QUESTION_ANSWER_TEXT
                  },
                  on: {
                    blur: function($event) {
                      return _vm.answerTheQuestion(_vm.answerData)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.answerData.answer[0],
                        "TEST_QUESTION_ANSWER_TEXT",
                        $event.target.value
                      )
                    }
                  }
                })
              : _c("div", [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.answerData.answer[0].TEST_QUESTION_ANSWER_TEXT
                      ) +
                      "\n\t\t\t\t"
                  )
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grade-result" }, [
            _c("i", { class: _vm.getFeedbackIcon() })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("question-summary"),
      _vm._v(" "),
      _vm.testMode !== "grading"
        ? _c("test-buttons", { on: { "answer-save": _vm.submitAnswer } })
        : _c("div", [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.$t("MAIN_CONTENT.NumericQuestion.acceptableAnswers")
                ) +
                "\n\t\t"
            ),
            _c(
              "ul",
              _vm._l(_vm.activeQuestionAnswers, function(ans, index) {
                return _c("li", { key: index }, [
                  _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(ans.ANSWER_TEXT) + "\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "badge" }, [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.NumericQuestion.points", {
                            points: ans.POINTS
                          })
                        ) +
                        "\n\t\t\t\t"
                    )
                  ])
                ])
              }),
              0
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }